var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItem',{attrs:{"label":_vm.model.variable.label,"inline":_vm.inline}},[_c('Input',{attrs:{"type":"textarea","autosize":{minRows: 2,maxRows: 5}},model:{value:(_vm.model.val),callback:function ($$v) {_vm.$set(_vm.model, "val", $$v)},expression:"model.val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }